import { BUSCAR_TIPOS_DOCUMENTOS } from '../../actions/types'

const initialState = undefined

export default function reducerBuscarTiposDocumento (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_TIPOS_DOCUMENTOS: {
      const tipos = action.payload.data;
      if(tipos){
        return tipos
      }
      return initialState

    }
    default: {
      return state
    }
  }
}
